/* eslint-disable security/detect-object-injection */
import { Loader, withModalContext } from '@jutro/components';
import {
    FormattedDate,
    FormattedMessage,
    TranslatorContext,
} from '@jutro/locale';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { JobUtil } from '@xengage/gw-portals-util-js';
import { ViewModelForm, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import appConfig from 'app-config';
import { RenewalService, UserService } from 'gw-capability-gateway';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import UnderwritingComponent from 'gw-capability-gateway-react/Components/UnderwritingComponent/UnderwritingComponent';
import CancellationReason from 'gw-capability-gateway-react/Renewal/WithDrawConfirmation/CancellationReason';
import TWIACommercialPolicySummary from "twia-capability-quoteandbind-cp-react/components/TWIACommercialPolicySummary/TWIACommercialPolicySummary";
import TWIAResPolicySummary from "twia-capability-quoteandbind-residential-react/components/PolicySummary/PolicySummary";
import styles from 'gw-capability-gateway-react/Renewal/Renewal.module.scss';
import gatewayMessages from '../../twiagateway.messages';
import messages from './Summary.messages';
import metadata from './Summary.metadata.json5';

class RenewalsSummary extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        authHeader: PropTypes.shape({
            Authorization: PropTypes.string,
        }).isRequired,
        fromAccountLanding: PropTypes.shape({
            quoteDetailsData: PropTypes.shape({
                jobNumber: PropTypes.string.isRequired,
                loadRenewalSummary: PropTypes.shape({}).isRequired,
                updateJobSummary: PropTypes.func.isRequired,
            }),
        }).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func.isRequired,
        }).isRequired,
    };

    state = {
        showContinueRenewalButton: false,
        canWithdraw: false,
        isLoading: true,
        hasOptions: false,
        options: [],
    };

    customerRequestOption = {
        id: 'customerRequestOption',
        code: 'customerRequestOption',
        displayName: messages.customerRequest,
        secondaryLabel: messages.decidedToAllowRenewPolicy,
    };

    insurerRequestOption = {
        id: 'insurerRequestOption',
        code: 'insurerRequestOption',
        displayName: messages.insurerRequest,
        secondaryLabel: messages.decidedToAllowRenewPolicy,
    };

    componentDidMount() {
        this.canWithdraw();
        this.initCloseOptions();
        this.getShowContinueRenewal();
    };

    getNewPremium = () => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadRenewalSummary: renewal },
            },
        } = this.props;
        const totalPremium = _.get(renewal, 'latestPeriod.totalPremium');
        const taxesAndFees = _.get(renewal, 'latestPeriod.taxesAndFees');

        return (
            <FormattedMessage
                {...messages.totalPremiumAndTaxes}
                values={{
                    totalPremium: (
                        <CurrencyField
                            id="totalPremium"
                            value={totalPremium}
                            readOnly
                            hideLabel
                            datatype="object"
                            className={styles.taxesAndFees}
                        />
                    ),
                    taxesAndFees: (
                        <CurrencyField
                            id="taxesAndFees"
                            value={taxesAndFees}
                            readOnly
                            hideLabel
                            datatype="object"
                            className={styles.taxesAndFees}
                        />
                    ),
                }}
            />
        );
    };

    getPremiumPercentage = () => {
        const translator = this.context;
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadRenewalSummary: renewal },
            },
        } = this.props;

        return translator(messages.increaseOf, {
            value: _.get(renewal, 'changeInCostPercentage'),
        });
    };

    getShowContinueRenewal = async () => {
        const { authHeader } = this.props;
        const permissionDTO = {
            permission: 'createrenewal',
        };
        const showContinueRenewalButton =
            await UserService.hasUserSystemPermission(
                permissionDTO,
                authHeader
            );

        this.setState({ showContinueRenewalButton, isLoading: false });
    };

    canWithdraw = () => { 
        const unsupportedWithdrawLobs = ['CommercialProperty','Homeowners']; 
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadRenewalSummary: renewal },
            },
        } = this.props;

        if (!_.isEmpty(renewal)) {
            const translator = this.context;
            const {productCode} = renewal;
            const canWithdrawForProduct = unsupportedWithdrawLobs.indexOf(productCode) === -1;
            
            if (
                renewal.status !==
                    translator({
                        id: 'typekey.PolicyPeriodStatus.Bound',
                        defaultMessage: 'Bound',
                    }) &&
                !renewal.closeDate
            ) {
                this.setState({ canWithdraw: canWithdrawForProduct });
            }
        }
    };

    initCloseOptions = () => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadRenewalSummary: renewal },
            },
        } = this.props;
        const options = [];

        if (renewal.canPendingNonRenew) {
            options.push(this.customerRequestOption);
            this.setState({ hasOptions: true, options });
        }

        if (renewal.canPendingNotTaken) {
            options.push(this.insurerRequestOption);
            this.setState({ hasOptions: true, options });
        }
    };

    onContinueTransaction = () => {
        const { lobRenewalURL } = appConfig;
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadRenewalSummary: renewal },
            },
            history,
        } = this.props;
        const productCode = _.get(
            renewal,
            'productCode'
        );

        if (!_.isEmpty(lobRenewalURL[productCode])) {
            const redirectLobPath = lobRenewalURL[productCode];

            history.push(redirectLobPath, {
                jobNumber: renewal.jobNumber,
                policyNumber: renewal.policy.policyNumber,
                landingFrom: 'quoteSummary',
            });
        } else {
            JobUtil.openJobInXCenter(renewal.jobNumber);
        }
    };

    updateWithDrawRenewal = (jobStatusCode, renewal) => {
        const translator = this.context;
        const status = translator({
            id: `typekey.PolicyPeriodStatus.${jobStatusCode}`,
            defaultMessage: jobStatusCode,
        });

        _.set(renewal, 'status', status);
        _.set(renewal, 'statusCode', jobStatusCode);
        this.updateJobSummary(renewal);
        this.setState({ hasOptions: false, options: [] });
    };

    withDrawRenewal = () => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadRenewalSummary: renewal },
            },
            authHeader,
            modalContext,
        } = this.props;

        RenewalService.withdrawRenewalByRenewalNumber(
            renewal.jobNumber,
            authHeader
        ).then(
            () => {
                this.updateWithDrawRenewal('Withdrawn', renewal);
            },
            () => {
                modalContext
                    .showAlert({
                        title: gatewayMessages.modalError,
                        message: messages.failedToRenewal,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok,
                    })
                    .catch(_.noop);
            }
        );
    };

    onWithdrawTransaction = () => {
        const translator = this.context;
        const { hasOptions, options } = this.state;
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadRenewalSummary: renewal },
            },
            authHeader,
            modalContext,
        } = this.props;
        let jobStatusCode = '';

        if (hasOptions) {
            const componentProps = {
                title: translator(messages.reasonForCancellingRenew),
                actionBtnLabel: translator(messages.cancelCtrlRenewal),
                cancelBtnLabel: translator(messages.doNotCancel),
                reasons: options,
                withDrawRenewal: () => this.withDrawRenewal(),
            };

            modalContext
                .showModal(<CancellationReason {...componentProps} />)
                .then(optionsModel => {
                    let jobPromise;

                    if (optionsModel === this.customerRequestOption.code) {
                        jobPromise = RenewalService.markRenewalNotTaken(
                            renewal.jobNumber,
                            authHeader
                        );
                        jobStatusCode = 'NotTaking';
                    } else if (
                        optionsModel === this.insurerRequestOption.code
                    ) {
                        jobPromise = RenewalService.markRenewalNonRenew(
                            renewal.jobNumber,
                            authHeader
                        );
                        jobStatusCode = 'NonRenewing';
                    }

                    jobPromise.then(
                        () => {
                            this.updateWithDrawRenewal(jobStatusCode, renewal);
                        },
                        () => {
                            modalContext
                                .showAlert({
                                    title: gatewayMessages.modalError,
                                    message: messages.failedToRenewal,
                                    status: 'error',
                                    icon: 'mi-error-outline',
                                    confirmButtonText: commonMessages.ok,
                                })
                                .catch(_.noop);
                        }
                    );
                })
                .catch(_.noop);
        } else {
            modalContext
                .showConfirm({
                    title: messages.withdrawTheRenewal,
                    message: messages.sureWithdrawRenew,
                    status: 'warning',
                    icon: 'mi-error-outline',
                    cancelButtonText: messages.doNotWithdraw,
                    confirmButtonText: messages.withdrawCtrlRenewal,
                })
                .then(results => {
                    if (results === 'cancel' || results === 'close') {
                        return _.noop();
                    }

                    return this.withDrawRenewal();
                }, _.noop);
        }
    };
    
    // changes done for renewal
    hasUwIssues = uwIssues => uwIssues?.filter(uw=>(uw.currentBlockingPoint !=='NonBlocking'
            && uw.currentBlockingPoint !== 'Rejected' && !uw.hasApprovalOrRejection)).length > 0;

    getPolicyFormattedInfo = message => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadRenewalSummary: renewal },
            },
        } = this.props;

        return (
            <FormattedMessage
                {...message}
                values={{
                    lob: renewal.policy.product.productName,
                    policyNumber: renewal.latestPeriod.policyNumber,
                }}
            />
        );
    };

    getPolicyQuotedInfo = message => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadRenewalSummary: renewal },
            },
        } = this.props;

        return (
            <FormattedMessage
                {...message}
                values={{
                    lob: renewal.policy.product.productName,
                    policyNumber: renewal.latestPeriod.policyNumber,
                    effectiveDate: (
                        <FormattedDate
                            value={new Date(renewal.effectiveDate)}
                        />
                    ),
                }}
            />
        );
    };

    getNotificationContent = () => {
        const translator = this.context;
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadRenewalSummary: renewal },
            },
        } = this.props;
        const { canWithdraw, hasOptions } =
            this.state;
        const content = {};
        const isHomeowners = renewal.productCode === 'Homeowners';

        if (
            renewal &&
            renewal.statusCode === 'Draft' &&
            !this.hasUwIssues(renewal.underwritingIssues) &&
            !renewal.isEditLocked
        ) {
            content.infoMessageTitle = isHomeowners 
            ? translator(messages.residentialRenewalDraft, {
                policyNumber: renewal.latestPeriod.policyNumber
            })
            : translator(messages.renewalPolicyDraft, {
                policyNumber: renewal.latestPeriod.policyNumber
            });
            content.optionalMessageContent =
                canWithdraw &&
                (hasOptions
                    ? translator(messages.selectReasonForCancellation)
                    : translator(messages.withdrawRenewalTransaction));
            content.withDrawContent = hasOptions
                ? messages.cancelRenewal
                : messages.withdrawRenewal;
            content.continueContent = messages.editRenewal;
        }

        if (
            renewal &&
            renewal.statusCode === 'Quoted' &&
            !this.hasUwIssues(renewal.underwritingIssues) &&
            !renewal.isEditLocked
        ) {
            content.infoMessageTitle = isHomeowners 
            ? translator(messages.residentialRenewalQuoted, {
                policyNumber: renewal.latestPeriod.policyNumber
            })
            : this.getPolicyQuotedInfo(
                messages.renewalPolicyQuoted
            );
            content.optionalMessageContent =
                canWithdraw &&
                (hasOptions
                    ? translator(messages.selectReasonForCancellation)
                    : translator(messages.withdrawRenewalTransaction));
            content.withDrawContent = hasOptions
                ? messages.cancelRenewal
                : messages.withdrawRenewal;
            content.continueContent = messages.editRenewal;
        }

        if (renewal && renewal.statusCode === 'Renewing') { // DE17529
            content.infoMessageTitle = isHomeowners ?
                translator(messages.renewalRenewingRes, {
                    policyNumber: renewal.latestPeriod.policyNumber
                })
                : translator(messages.renewalRenewing, {
                    policyNumber: renewal.latestPeriod.policyNumber
                });
            content.continueContent = messages.editRenewal;
        }

        if (renewal && renewal.statusCode === 'NonRenewing') {
            content.infoMessageTitle = translator(messages.renewalNonRendering);
        }

        if (renewal && renewal.statusCode === 'NotTaking') {
            content.infoMessageTitle = translator(messages.renewalNotTaken);
        }

        if (renewal && renewal.statusCode === 'Scheduled') {
            content.infoMessageTitle = isHomeowners ?
                translator(messages.renewalScheduledRes, {
                    policyNumber: renewal.latestPeriod.policyNumber
                })
                : translator(messages.renewalScheduled, {
                    policyNumber: renewal.latestPeriod.policyNumber
                });
        }

        if (renewal && renewal.statusCode === 'Withdrawn') {
            content.infoMessageTitle = translator(messages.renewalWithdrawn);
            content.infoMessageDescription = '';
        }
        
        
        if (renewal && renewal.statusCode === 'Submitted_Ext') {
            content.infoMessageTitle = isHomeowners ?
                translator(messages.renewalSubmittedHO, {
                    policyNumber: renewal.latestPeriod.policyNumber // DE17742
                }) :
                translator(messages.renewalSubmittedCP, {
                    policyNumber: renewal.latestPeriod.policyNumber
                });
        }

        if(renewal && renewal.statusCode === 'Expired'){
            content.infoMessageTitle = translator(messages.renewalExpired, {
                policyNumber: renewal.latestPeriod.policyNumber
            });
        }
        
        if (renewal && renewal.statusCode === 'Bound') {
            content.infoMessageTitle = isHomeowners ?
                translator(messages.renewalScheduledRes, {
                    policyNumber: renewal.latestPeriod.policyNumber
                })
                : translator(messages.renewalScheduled, {
                    policyNumber: renewal.latestPeriod.policyNumber
                });
            content.infoMessageDescription = '';
        }

        return {
            infoMessageTitle: content.infoMessageTitle,
            infoMessageDescription: content.infoMessageDescription,
            optionalInfoMessageDescription: content.optionalMessageContent,
            withDrawContent: content.withDrawContent,
            continueContent: content.continueContent,
        };
    };

    getSubmissionToProceed = () => {
        const { showContinueRenewalButton, canWithdraw } = this.state;
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadRenewalSummary: renewal },
            },
        } = this.props;

        if (
            renewal &&
            ![
                'Bound',
                'Quoted',
                'Withdrawn',
                'NotTaking',
                'NonRenewing',
                'Expired'
            ].includes(renewal.statusCode) &&
            !this.hasUwIssues(renewal.underwritingIssues) &&
            !renewal.isEditLocked
        ) {
            return {
                isContinueTransaction:
                    showContinueRenewalButton &&
                    !renewal.isEditLocked,
                isWithdrawTransaction: canWithdraw,
            };
        }

        if (
            renewal &&
            [
                'Bound',
                'Withdrawn',
                'Expired',
                'NotTaking',
                'NonRenewing',
            ].includes(renewal.statusCode)
        ) {
            return {
                isContinueTransaction: false,
                isWithdrawTransaction: false,
            };
        }

        return {
            isContinueTransaction:
                showContinueRenewalButton &&
                !renewal.isEditLocked,
            isWithdrawTransaction: canWithdraw,
        };
    };

    getPolicyLinkVisible = () => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadRenewalSummary: renewal },
            },
        } = this.props;

        return (
            !_.isEmpty(renewal.latestPeriod) &&
            renewal.latestPeriod.policyNumber &&
            renewal.latestPeriod.policyNumber !== 'Unassigned'
        );
    };

    updateJobSummary = renewal => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { updateJobSummary },
            },
        } = this.props;

        if (updateJobSummary) {
            updateJobSummary(renewal);
        }
    };

    getPaymentMethod = () => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadRenewalSummary: renewal },
            },
            viewModelService
        } = this.props;
        const payMethod = renewal.paymentMethod_TWIA;
        const translator = this.context;

        if (payMethod) {
            const code = viewModelService?.productMetadata?.get('pc').types.getTypelist('PaymentMethod_TWIA').getCode(payMethod);

            return translator({id: code.name});
        }
 
            return null;
        
    };

    render() {
        const { isLoading } = this.state;
        const translator = this.context;
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadRenewalSummary: renewal, lobData },
            },authUserData
        } = this.props;
        const associationName = _.get(authUserData, 'associationName_TWIA');
        // DE17201
        const statusCode = _.get(renewal, 'statusCode')
        const quotedState = ['Quoted', 'Renewing', 'NotTaken', 'Withdrawn', 'Expired', 'Submitted_Ext'].includes(statusCode);

        if (_.isEmpty(renewal)) {
            return <Loader loaded={!isLoading} />;
        }

        const overrides = {
            quoteNotification: {
                notificationContent: this.getNotificationContent(),
                transactionVisibleActions: this.getSubmissionToProceed(),
                associationName, // DE17344
                renewal
            },
            underwritingTable: {
                job: renewal,
                continueJob: this.getSubmissionToProceed(),
                jobService: RenewalService,
                onUpdateJobSummary: this.updateJobSummary,
            },
            policyInfoLink: {
                visible: this.getPolicyLinkVisible(),
            },
            columnSpace: {
                visible: true,
                className:
                    (renewal.statusCode === 'Quoted' &&
                        renewal.changeInCost.amount === 0) ||
                    (renewal.statusCode === 'Quoted' &&
                        (renewal.changeInCost.amount > 0 ||
                            renewal.changeInCost.amount < 0))
                        ? ''
                        : styles.columnHorizontal,
            },
            quoteTotalPremiumId: {
                visible: quotedState && associationName !== "twia"  
            },
            totalPremiumCommID : {
               visible: quotedState && associationName === "twia" // DE17187 DE17528
            },
            quoteTotalCostId: {
                visible: quotedState && associationName !== "twia"  
            },
            quotedCostSeparator: {
                visible: quotedState && associationName !== "twia"
            },
            quoteTaxesandFeesId: {
                visible: quotedState && associationName !== "twia" // DE17198 DE17528
            },
            quotedChangeInCost: {
                visible:
                    renewal.statusCode === 'Quoted' &&
                    (renewal.changeInCost.amount > 0 ||
                        renewal.changeInCost.amount < 0),
            },
            viewPolicyLink: {
                content: translator(messages.viewCurrentPolicy),
                to: `/policies/${renewal.latestPeriod.policyNumber}/summary`,
            },
            newPremiumContainer: {
                content: this.getNewPremium(),
            },
            changeInCostPercentage: {
                message: this.getPremiumPercentage(),
            },
            quotedCostContainer: {
                visible: quotedState,
            },
            twiaCPPolicySummaryContainer:{
                visible : renewal && ['Bound', 'Renewing', 'Quoted', 'Submitted_Ext'].includes(renewal.statusCode) && _.get(renewal,'latestPeriod.policyLines[0].lineOfBusinessCode') =='CPLine' 
            },
            twiaHOPolicySummaryContainer:{
                visible : renewal && ['Bound', 'Renewing', 'Quoted', 'Submitted_Ext'].includes(renewal.statusCode) && _.get(renewal,'latestPeriod.policyLines[0].lineOfBusinessCode') !=='CPLine' ,
            },
            twiaPolicySummary: {
                visible : renewal && ['Bound', 'Renewing', 'Quoted', 'Submitted_Ext'].includes(renewal.statusCode),
                lobData_TWIA: lobData,
                renewalData : renewal,
                isRenewalSummary:true
            },
            paymentMethodId:{
                value: this.getPaymentMethod()
            },
            paymentDetailsContainer:{
                visible: quotedState,
            },
        };
        const resolvers = {
            resolveClassNameMap: styles,
            resolveComponentMap: {
                underwritingcomponent: UnderwritingComponent,
                TWIACommercialPolicySummary,
                TWIAResPolicySummary
            },
            resolveCallbackMap: {
                onContinueTransaction: this.onContinueTransaction,
                onWithdrawTransaction: this.onWithdrawTransaction,
            },
        };
        const readValue = (id, path) => readViewModelValue(
                metadata.pageContent,
                renewal,
                id,
                path,
                overrides
            );

        return (
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={renewal}
                overrideProps={overrides}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
                resolveValue={readValue}
            />
        );
    }
}

export default withViewModelService(withAuthenticationContext(withModalContext(RenewalsSummary)));
